/**
 * api/deliveryAudit.js — Auditoria de Entrega (revisão profunda de código · P1).
 * GET  /projects/{id}/delivery-audit           → último relatório
 * POST /projects/{id}/delivery-audit/generate  → roda a auditoria (lê o código real)
 * GET  /projects/{id}/delivery-audit/spec.md   → baixa o .md de correção
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from './client';

export function useDeliveryAudit(projectId) {
  const api = useApi();
  return useQuery({
    queryKey: ['delivery-audit', projectId],
    queryFn:  () => api.get(`/projects/${projectId}/delivery-audit`),
    enabled:  Boolean(projectId),
  });
}

export function useGenerateDeliveryAudit(projectId) {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationKey: ['ai'],
    meta: {
      aiLabel: 'A IA está auditando o código entregue…',
      aiSublabel: 'Lendo o código real linha a linha e validando cada requisito com evidência (arquivo:linha).',
    },
    mutationFn: () => api.post(`/projects/${projectId}/delivery-audit/generate`, {}),
    onSuccess:  () => {
      qc.invalidateQueries({ queryKey: ['delivery-audit', projectId] });
      qc.invalidateQueries({ queryKey: ['delivery-audit-history', projectId] });
    },
  });
}

/** useDeliveryAuditHistory — histórico (tendência) das rodadas de auditoria (P3). */
export function useDeliveryAuditHistory(projectId) {
  const api = useApi();
  return useQuery({
    queryKey: ['delivery-audit-history', projectId],
    queryFn:  () => api.get(`/projects/${projectId}/delivery-audit/history`),
    enabled:  Boolean(projectId),
  });
}

/** URL do .md de correção (download direto, com token do app via api base). */
export function deliveryAuditSpecPath(projectId) {
  return `/projects/${projectId}/delivery-audit/spec.md`;
}
